// extracted by mini-css-extract-plugin
module.exports = {"native":"native_1Re","checkbox":"checkbox_3fV","label":"label_3Ol"};